import { useEffect } from "react";
import AOS from "aos";
import offerone from "../../assets/img/offerone.png";
import offertwo from "../../assets/img/offertwo.png";
import offerthree from "../../assets/img/offerthree.png";

const WhatWeOffer = () => {
  useEffect(() => {
    AOS.refresh();
  }, []);

  const offerings = [
    {
      title: "Innovation",
      description:
        "We design all our programs to help kids be creative, explore new ideas, and enjoy learning through fun and practical experiences.",
      image: offerone,
    },
    {
      title: "Empowerment:",
      description:
        "Through every session, we're building kids who believe in themselves and in what they can create.",
      image: offertwo,
    },
    {
      title: "Collaboration:",
      description:
        "We encourage kids to work together, learn from each other, and grow through shared experiences and teamwork.",
      image: offerthree,
    },
  ];

  return (
    <section className="py-16 px-5 md:px-10 lg:px-32 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2
            data-aos="fade-down"
            data-aos-duration="2000"
            data-aos-delay="100"
            className="text-3xl md:text-4xl lg:text-4xl font-DM_SANS font-bold text-[#1B1B1B]"
          >
            Here's What We <span className="text-[#FF4B01]">Offer</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {offerings.map((offering, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-duration="2000"
              data-aos-delay={200 + index * 200}
              className="bg-[#FFFFFF] rounded-tr-[50px] rounded-bl-[50px] p-4 transition-shadow duration-300"
              style={{
                boxShadow:
                  "0 -8px 25px -5px rgba(0, 0, 0, 0.1), 0 -4px 10px -3px rgba(0, 0, 0, 0.05)",
              }}
            >
              <div className="w-24 h-24 mb-2 items-start flex">
                <img
                  src={offering.image}
                  alt={offering.title}
                  className="w-full h-full rounded-full object-cover"
                />
              </div>
              <h3 className="text-xl font-bold text-[#1B1B1B] font-DM_SANS mb-2 text-left">
                {offering.title}
              </h3>
              <p className="text-[#475569] font-DM_SANS font-normal text-[15px] leading-relaxed text-left">
                {offering.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;

// import offerone from "../../assets/img/offerone.png";
// import offertwo from "../../assets/img/offertwo.png";
// import offerthree from "../../assets/img/offerthree.png";
// import { Fade, Slide, Zoom } from "react-reveal";
// import Shake from "react-reveal/Shake";
// import Flip from "react-reveal";
// import AOS from "aos";
// import { useEffect } from "react";

// const WhatWeOffer = () => {
//   useEffect(() => {
//     AOS.refresh();
//   }, []);
//   const offerings = [
//     {
//       title: "Innovation",
//       description:
//         "We design all our programs to help kids be creative, explore new ideas, and enjoy learning through fun and practical experiences.",
//       image: offerone,
//     },
//     {
//       title: "Empowerment:",
//       description:
//         "Through every session, we're building kids who believe in themselves and in what they can create.",
//       image: offertwo,
//     },
//     {
//       title: "Collaboration:",
//       description:
//         "We encourage kids to work together, learn from each other, and grow through shared experiences and teamwork.",
//       image: offerthree,
//     },
//   ];

//   return (
//     <section className="py-16 px-5 md:px-10 lg:px-28 bg-white">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center mb-12">
//           <Shake>
//             <h2
//               data-aos="flip-up"
//               data-aos-duration="1000"
//               className="text-3xl md:text-4xl lg:text-4xl font-DM_SANS font-bold text-[#1B1B1B]"
//             >
//               Here's What We <span className="text-[#FF4B01]">Offer</span>
//             </h2>
//           </Shake>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//           {offerings.map((offering, index) => (
//             <Flip>
//               <div
//                 data-aos="fade-up"
//                 data-aos-duration="1000"
//                 key={index}
//                 className="bg-[#FFFFFF] rounded-tr-[50px] rounded-bl-[50px] p-4 transition-shadow duration-300"
//                 style={{
//                   boxShadow:
//                     "0 -8px 25px -5px rgba(0, 0, 0, 0.1), 0 -4px 10px -3px rgba(0, 0, 0, 0.05)",
//                 }}
//               >
//                 <div className="w-24 h-24 mb-2 items-start flex">
//                   <img
//                     src={offering.image || "/placeholder.svg"}
//                     alt={offering.title}
//                     className="w-full h-full rounded-full object-cover"
//                   />
//                 </div>
//                 <h3 className="text-xl font-bold text-[#1B1B1B] font-DM_SANS mb-2 text-left">
//                   {offering.title}
//                 </h3>
//                 <p className="text-[#475569] font-DM_SANS font-normal text-[15px] leading-relaxed text-left">
//                   {offering.description}
//                 </p>
//               </div>
//             </Flip>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhatWeOffer;

// import offerone from "../../assets/img/offerone.png";
// import offertwo from "../../assets/img/offertwo.png";
// import offerthree from "../../assets/img/offerthree.png";

// const WhatWeOffer = () => {
//   const offerings = [
//     {
//       title: "Innovation",
//       description:
//         "We design all our programs to help kids be creative, explore new ideas, and enjoy learning through fun and practical experiences.",
//       image: offerone,
//     },
//     {
//       title: "Empowerment:",
//       description:
//         "Through every session, we're building kids who believe in themselves and in what they can create.",
//       image: offertwo,
//     },
//     {
//       title: "Collaboration:",
//       description:
//         "We encourage kids to work together, learn from each other, and grow through shared experiences and teamwork.",
//       image: offerthree,
//     },
//   ];

//   return (
//     <section className="py-16 px-5 md:px-10 lg:px-24 bg-white">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
//             Here's What We <span className="text-orange-500">Offer</span>
//           </h2>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//           {offerings.map((offering, index) => (
//             <div
//               key={index}
//               className="bg-gray-50 rounded-3xl p-8 text-center hover:shadow-lg transition-shadow duration-300"
//             >
//               <div className="w-24 h-24 mx-auto mb-6">
//                 <img
//                   src={offering.image || "/placeholder.svg"}
//                   alt={offering.title}
//                   className="w-full h-full rounded-full object-cover"
//                 />
//               </div>
//               <h3 className="text-xl font-bold text-gray-900 mb-4">
//                 {offering.title}
//               </h3>
//               <p className="text-gray-600 leading-relaxed">
//                 {offering.description}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhatWeOffer;
